import React, { useState, useEffect } from 'react';
import { useFragment } from 'react-relay';
import { graphql } from 'babel-plugin-relay/macro';
import { Container, Row, Col } from 'react-bootstrap';
import ReactHtmlParser from 'react-html-parser';

import { transformSource } from '../../utils/helpers';
import type { HeroBanner$key } from './__generated__/HeroBanner.graphql';
import './HeroBanner.sass';

import HumanTouch from '../../uikit/Links/HumanTouch';
import Bubble from '../../uikit/Bubble';

import { ReactComponent as Dude } from './dude.svg';

interface Props {
	bannerData: HeroBanner$key | null;
	registerButtonLabel: string;
}

function HeroBanner(props: Props) {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const heroBannerData: any = useFragment(
		graphql`
			fragment HeroBanner on HomePublishedContent {
				bannerContent
				bannerDate
				bannerMessages
			}
		`,
		props.bannerData
	);
	const { bannerContent, bannerDate, bannerMessages } = heroBannerData;
	const [bubbleText, setBubbleText] = useState(bannerMessages[0]);

	useEffect(() => {
		let index = 1;
		const intervalId = setInterval(() => {
			if (bannerMessages.length > 0) {
				if (bannerMessages.length - 1 >= index) {
					setBubbleText(bannerMessages[index]);
					index += 1;
				} else {
					index = 0;
				}
			}
		}, 5000);

		return () => clearInterval(intervalId);
	}, [bannerMessages]);
	return (
		<section className="hero-banner">
			<Container>
				<Row>
					<Col
						xs={12}
						md={10}
						lg={{ offset: 1, span: 10 }}
						xl={8}
						className="hero-banner__inner"
					>
						<h1 className="uikit-heading-hg hero-banner__heading">
							{ReactHtmlParser(bannerContent, {
								transform: transformSource,
							})}
						</h1>
						<time
							className="uikit-text-large hero-banner__date"
							dateTime={bannerDate}
						>
							{bannerDate}
						</time>
						<div className="hero-banner__button">
							<HumanTouch
								hrefSource="/register-to-the-conference"
								label={props.registerButtonLabel}
								isExternal={false}
							/>
						</div>
						<div className="hero-banner__animation">
							<Bubble align="left-bottom" text={bubbleText} />
							<Dude />
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	);
}

export default HeroBanner;
